import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';

import {
    IsObject,
} from '../../../libraries/Tool';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ObjectDialog(props) {

    const { translate, open, onClose, onAgree, scriptsteps, options } = props;
    const [object, setObject] = React.useState([{ key: "", value: "" }]);

    const addItem = () => {
        let _object = JSON.parse(JSON.stringify(object));
        _object.push({ key: "", value: "" });
        setObject(_object);
    }

    const deleteItem = (i) => {
        if (object.length > 1) {
            let _object = JSON.parse(JSON.stringify(object));
            _object.splice(i, 1);
            setObject(_object);
        }
    }

    useEffect(() => {
        if (options.value && IsObject(options.value) && options.value.toString().search(new RegExp(/\{.*?\}/g)) !== -1) {
            let value = Object.keys(JSON.parse(options.value)).map((key) => ({ "key": key, "value": JSON.parse(options.value)[key] }));
            setObject(value);
        } else {
            setObject([{ key: "", value: "" }]);
        }
    }, [options.value])

    return (
        <div>
            <Dialog
                open={open}
                onClose={onClose}
                onAgree={onAgree}
                maxWidth="sm"
                fullWidth
                TransitionComponent={Transition}
            >
                <DialogTitle>{translate('createobject')}</DialogTitle>
                <DialogContent sx={{ display: "grid", maxHeight: "90vh", overflow: "auto" }}>
                    {
                        object.map((item, i) => (
                            <Box sx={{ display: "flex", alignItems: "center", paddingTop: 2, gap: 1 }} key={`object-${i}`}>
                                <TextField
                                    size='small'
                                    fullWidth
                                    label={`${translate('key')} ${i + 1}`}
                                    placeholder='product'
                                    defaultValue={object[i].key}
                                    onChange={(e) => object[i].key = e.target.value}
                                />
                                <span>:</span>
                                <Autocomplete
                                    size='small'
                                    freeSolo
                                    options={scriptsteps?.filter((step) => step?.output?.icon)?.map(item => item.output.key)}
                                    onChange={(event, newOption) => {
                                        let _object = JSON.parse(JSON.stringify(object));
                                        _object[i].value = (newOption) ? newOption : '';
                                        setObject(_object);
                                    }}
                                    getOptionLabel={(option) => option}
                                    fullWidth
                                    value={object[i].value}
                                    renderInput=
                                    {
                                        (params) =>
                                            <TextField
                                                {...params}
                                                label={`${translate('value')} ${i + 1}`}
                                                placeholder='pen'
                                                onChange={(e) => object[i].value = e.target.value}
                                            />
                                    }
                                />
                                <Tooltip title={translate('deleteobject')} arrow>
                                    <IconButton onClick={(i) => { deleteItem(i) }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        ))
                    }
                </DialogContent>
                <DialogActions>
                    <Tooltip title={translate('addnewobject')} arrow>
                        <IconButton style={{ position: "absolute", left: 18 }} onClick={addItem}>
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Tooltip>
                    <Button variant="contained" size="small" disableElevation onClick={onClose} color="secondary">
                        {translate('cancel')}
                    </Button>
                    <Button variant="contained" size="small" disableElevation onClick={() => { onAgree(options.index, options.name, object) }} color="primary">
                        {translate('ok')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default withTranslate(ObjectDialog);
